import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Befundmitteilung, BefundmitteilungExternApi } from './befundmitteilung';
import { HttpClient, HttpParams } from '@angular/common/http';
import { MatDialog } from '@angular/material/dialog';
import { LocalStorageService } from '../../../../projects/kiene-core/src/lib/services/local-storage/local-storage.service';
import { Router } from '@angular/router';
import {
    PdfViewerDesktopService,
    PdfViewerDialogInput,
} from '../../../../projects/kiene-core/src/lib/components/pdf-viewer/kiene-pdf-viewer/kiene-pdf-viewer-desktop/pdf-viewer-desktop.service';
import { API_BASE_URL_SERVICE } from '../../../../projects/kiene-core/src/lib/kiene-core.config';
import { Empfaenger } from '../../../../projects/kiene-core/src/lib/components/pdf-viewer/kiene-pdf-viewer/classes/empfaenger';

export function empfaengerFromMailAdressen(mailAdressen?: string): Empfaenger[] {
    if (!mailAdressen?.trim()) {
        return [];
    }
    return mailAdressen
        .split(';')
        .map(s => s.trim())
        .filter(Boolean)
        .map(email => new Empfaenger(email, email.split('@')[0], true));
}

export function getBefundMailAdressen(befund: Befundmitteilung): string | undefined {
    return befund.mail_adressen?.trim() || befund.letzte_mail_adressen?.trim() || undefined;
}

@Injectable()
export class BefundmitteilungService {
    constructor(
        private readonly http: HttpClient,
        public dialog: MatDialog,
        private readonly localStorageService: LocalStorageService,
        private readonly router: Router,
        private readonly pdfViewerService: PdfViewerDesktopService,
        @Inject(API_BASE_URL_SERVICE) private readonly apiBaseUrl: string,
    ) {}

    recreateBefund(befund: Befundmitteilung) {
        return this.http.get<Befundmitteilung>(this.apiBaseUrl + 'befund/update_pdf.php?befund_id=' + befund.befund_id);
    }

    getPdfIdsForBefundmitteilung(befundId: number): Observable<BefundmitteilungExternApi> {
        const params = new HttpParams().set('dokument_typ', 1).set('befund_id', befundId);
        return this.http.get<BefundmitteilungExternApi>(this.apiBaseUrl + 'befund_dokument/read.php', {
            params: params,
        });
    }

    getNotizzettel(befund: Befundmitteilung) {
        if (befund) {
            const url = 'befund/pdf_create.php';
            let params = new HttpParams()
                .set('gruppe_id', befund?.gruppe_id?.toString())
                .set('tagebuch_nr', befund?.tagebuch_nr);
            if (befund.untersuchungsmaterial) {
                params = params.set('untersuchungsmaterial', befund?.untersuchungsmaterial);
            }
            if (befund.tierarzt) {
                params = params.set('tierarzt', befund?.tierarzt);
            }
            this.pdfViewerService.openPdfViewer(new PdfViewerDialogInput(url, params, 'Notizzettel'));
        }
    }

    deleteBefundmitteilung(befundmitteilung: Befundmitteilung) {
        return this.http.post(this.apiBaseUrl + 'befund/delete.php', befundmitteilung);
    }

    getPdfViewerEmailOptions(befundmitteilung: Befundmitteilung) {
        return {
            email: { sende_mail: true, kunde_id: befundmitteilung?.kunde_id },
            empfaenger: empfaengerFromMailAdressen(getBefundMailAdressen(befundmitteilung)),
        };
    }

    getPdfTitle(befundmitteilung: Befundmitteilung) {
        let title: string = befundmitteilung.gruppe_nr_intern
            ? befundmitteilung.gruppe_nr_intern
            : befundmitteilung.kunde_nr_intern?.toString();
        title +=
            ' ' +
            befundmitteilung.kunde +
            ', ' +
            befundmitteilung.kunde_ort +
            ' (' +
            befundmitteilung.tagebuch_nr +
            ') ' +
            this.ausgangsdatumAlsString(befundmitteilung);

        return title;
    }

    private ausgangsdatumAlsString(befundmitteilung: Befundmitteilung) {
        if (befundmitteilung) {
            let ausgang = befundmitteilung.ausgang;
            if (ausgang) {
                ausgang = new Date(ausgang);
                return ausgang.getDate() + '.' + (ausgang.getMonth() + 1) + '.' + ausgang.getFullYear();
            }
        }
        return '';
    }
}
